import React from "react";
import Grid from "@mui/material/Grid";

function GrauInovacaoGeral({ data, grau, classificação }) {
	return (
		<>
			<div className="d-flex justify-content-center mb-5">{data}</div>

			<h2>Grau de Inovação Geral</h2>
			<hr />
			<h1 className="mt-5">{grau}</h1>
			<h2>{classificação}</h2>
			<div className=" mt-5 text-center">
				<Grid
					container
					columnSpacing={{ xs: 1, sm: 2, md: 3 }}
					className="d-flex justify-content-center"
				>
					<Grid item xs={5} md={2}>
						<p>
							{" "}
							<b> = 1</b>
							<br />
							Não Inovadora
						</p>
					</Grid>
					<Grid item xs={5} md={2}>
						<p>
							{" "}
							<b> 1 &lt; GI &lt; 3</b>
							<br />
							Pouco Inovadora
						</p>
					</Grid>
					<Grid item xs={5} md={2}>
						<p>
							{" "}
							<b> 3 &le; GI &lt; 4 </b>
							<br />
							Inovadora Ocasional
						</p>
					</Grid>
					<Grid item xs={5} md={2}>
						<p>
							{" "}
							<b> &ge; 4 </b>
							<br />
							Inovadora Sistêmica
						</p>
					</Grid>
				</Grid>
			</div>
		</>
	);
}

export default GrauInovacaoGeral;
